/* Find in Stores (Google Maps + Geocoding) via Custom Element */
(function () {
  function loadGoogleMapsAPI(apiKey) {
    if (window.google && window.google.maps) return Promise.resolve();
    if (!apiKey) return Promise.reject(new Error('Missing Google Maps API key'));
    if (window.__gmapsPromise) return window.__gmapsPromise;
    window.__gmapsPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}`;
      script.async = true;
      script.defer = true;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error('Google Maps failed to load'));
      document.head.appendChild(script);
    });
    return window.__gmapsPromise;
  }

  class FindInStoresMap extends HTMLElement {
    connectedCallback() {
      this.apiKey = this.getAttribute('api-key') || '';
      this.country = this.getAttribute('country') || '';
      this.lat = parseFloat(this.getAttribute('default-lat')) || 39.8283;
      this.lng = parseFloat(this.getAttribute('default-lng')) || -98.5795;
      this.zoom = parseInt(this.getAttribute('default-zoom') || '4', 10);

      loadGoogleMapsAPI(this.apiKey)
        .then(() => {
          const center = { lat: this.lat, lng: this.lng };
          this.map = new google.maps.Map(this, {
            center,
            zoom: this.zoom,
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: true,
          });
          this.marker = new google.maps.Marker({ map: this.map, position: center, visible: false });
          this.geocoder = new google.maps.Geocoder();
        })
        .catch((err) => {
          console.error('[FindInStoresMap] ', err);
          this._dispatchStatus('Map could not load. Please add a valid Google Maps API key in Theme Settings.');
        });
    }

    search(zip) {
      if (!this.geocoder || !this.map) return;
      const cleaned = (zip || '').trim();
      if (!cleaned) {
        this._dispatchStatus('Please enter a ZIP code.');
        return;
      }
      const zipPattern = /^\d{5}(?:-\d{4})?$/;
      if (this.country === 'US' && !zipPattern.test(cleaned)) {
        this._dispatchStatus('Please enter a valid US ZIP code (e.g., 94103).');
        return;
      }
      this._dispatchStatus('Searching…');
      this.geocoder.geocode({
        address: cleaned,
        componentRestrictions: this.country ? { country: this.country } : undefined,
      }, (results, status) => {
        if (status !== 'OK' || !results || !results.length) {
          this._dispatchStatus('Sorry, we could not locate that ZIP code.');
          return;
        }
        const loc = results[0].geometry.location;
        this.marker.setPosition(loc);
        this.marker.setVisible(true);
        this.map.panTo(loc);
        this.map.setZoom(Math.max(10, this.zoom));
        this._dispatchStatus(`Showing results near ${cleaned}`);
      });
    }

    _dispatchStatus(message) {
      this.dispatchEvent(new CustomEvent('findinstores:status', {
        detail: { message },
        bubbles: true
      }));
    }
  }

  customElements.define('find-in-stores-map', FindInStoresMap);

  function initFindInStores(sectionEl) {
    const mapEl = sectionEl.querySelector('find-in-stores-map');
    const form = sectionEl.querySelector('.find-in-stores__form');
    const input = sectionEl.querySelector('.find-in-stores__input, .field__input');
    const statusEl = sectionEl.querySelector('.find-in-stores__status');

    function setStatus(msg, opts = { hidden: false }) {
      if (!statusEl) return;
      statusEl.textContent = msg;
      statusEl.hidden = !!opts.hidden;
    }

    if (mapEl) {
      mapEl.addEventListener('findinstores:status', (e) => {
        setStatus(e.detail?.message || '', { hidden: false });
      });
    }

    if (form && input && mapEl) {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        mapEl.search(input.value);
      });

      input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          mapEl.search(input.value);
        }
      });
    }
  }

  function onSectionLoad(evt) {
    const sectionEl = evt.target || evt.detail?.section;
    if (sectionEl && sectionEl.classList.contains('find-in-stores')) {
      initFindInStores(sectionEl);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.find-in-stores').forEach(initFindInStores);
  });
  document.addEventListener('shopify:section:load', onSectionLoad);
})();